/**
 * @Author: Florian Merel <florian>
 * @Date:   09-Dec-2020
 * @Email:  florian.merel@prokov.com
 * @Project: ComEditServer
 * @Filename: followup.js
 * @Last modified by:   florian
 * @Last modified time: 12-Jan-2021
 */

import axios from "axios";
import server from "../server.js";
import store from "@/store";
import servicesError from "../ServicesError.js";

const state = {
  loading: false,
  error: {},
  data: {},
};

const getters = {
  getData(context) {
    return context.data;
  },
};

const mutations = {
  setResponse(context, data) {
    context.error = null;
    context.data = data;
  },

  setError(context, error) {
    context.data = null;
    context.error = error;
  },

  setLoading(context, loading) {
    context.loading = loading;
  },

  setData(context, data) {
    context.data = data;
  },
};

const actions = {
  async followupTickets(context, params) {
    context.commit("setLoading", true);
    try {
      let res = await axios({
        method: "GET",
        url: server.url + server.urls.followup + "/tickets" + params,
        headers: server.getHeader(),
      });
      context.commit("setResponse", res);
      context.commit("setData", res.data);
    } catch (error) {
      if (servicesError.isConnection(error)) {
        servicesError.analyseErrorService(error.response.data);
        context.commit("setError", error.response.data);
      }
    }
    context.commit("setLoading", false);
  },

  async createFollowup(context, id) {
    context.commit("setLoading", true);
    try {
      let res = await axios({
        method: "POST",
        url: server.url + server.urls.followup + "/" + id,
        headers: server.getHeader(),
      });

      if (res.data && res.data.data && res.data.data.followup) {
        store.commit("tickets/updateTicket", {
          id: res.data.data.ticket.id,
          followUp: res.data.data.followup,
        });
      }
    } catch (error) {
      if (servicesError.isConnection(error)) {
        servicesError.analyseErrorService(error.response.data);
        context.commit("setError", error.response.data);
      }
    }
    context.commit("setLoading", false);
  },

  async moveFollowup(context, params) {
    context.commit("setLoading", true);
    try {
      let res = await axios({
        method: "PUT",
        url: server.url + server.urls.followup + "/" + params.id,
        data: params.data,
        headers: server.getHeader(),
      });
    } catch (error) {
      if (servicesError.isConnection(error)) {
        servicesError.analyseErrorService(error.response.data);
        context.commit("setError", error.response.data);
      }
    }
    context.commit("setLoading", false);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
